import { Alert, MantineColor, MantineSpacing, Text } from "@mantine/core"
import { IconAlertCircle } from "@tabler/icons-react"
import { CSSProperties, ReactNode } from "react"

type Props = {
  title?: ReactNode
  message: ReactNode
  fontSize?: "xs" | "sm" | "md" | "lg"
  bg?: MantineColor
  width?: string
  height?: string
  icon?: ReactNode
  my?: MantineSpacing | undefined
  messageStyles?: CSSProperties
  variant?: "error" | "info" | "success" | "admin" | "warning" | "primary"
}

export type InfoBoxProps = Props & {
  children?: ReactNode
}

export const InfoBox = ({
  title,
  message,
  fontSize = "sm",
  icon = <IconAlertCircle size="16" />,
  messageStyles = {},
  my,
  bg,
  width,
  height = "fit-content",
  variant = "info",
}: Props) => (
  <Alert
    title={title}
    icon={icon}
    fz={fontSize}
    styles={{ body: { gap: "0.25em" }, message: messageStyles }}
    bg={bg}
    w={width}
    h={height}
    my={my}
    variant={variant}
  >
    {typeof message === "string" ? (
      <Text fz={fontSize}>{message}</Text>
    ) : (
      message
    )}
  </Alert>
)
